const getKey = ({ application, page, component }: { application: string; page: string; component: string }) => {
  return `AFS_debug_${application}_${page}_${component}`
}

export interface DebugConfig {
  simulateVocApiCall?: 'failure' | 'success'
  vocApiUrl?: string
}

export const getDebugConfig = ({ application, page, component }: { application: string; page: string; component: string }): undefined | DebugConfig => {
  const key = getKey({ application, page, component })

  const configString = sessionStorage.getItem(key)

  if (!configString) {
    return undefined
  }

  return JSON.parse(configString) as DebugConfig
}
